import jishikaijiang from '../../Jishikaijiang/columns/ssc';
export default {
  list: Vue => {
    return jishikaijiang().list(Vue);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/History/columns/ssc.js